import { createAction } from '@reduxjs/toolkit';
import type { CompanyDepartmentDto } from '@/api-gen/api.schemas';

export const getAllDepartments = createAction('department/getAllDepartments');
export const getAllDepartmentsSuccess = createAction<CompanyDepartmentDto[]>('department/getAllDepartmentsSuccess');
export const getAllDepartmentsFailure = createAction<string>('department/getAllDepartmentsFailure');
